import script from "./authCommons.vue?vue&type=script&lang=js"
export * from "./authCommons.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__